export function isUrlHttp(url: string): boolean {
  try {
    const protocol = new URL(url).protocol
    return protocol === "http:" || protocol === "https:"
  } catch (error) {
    return false
  }
}
